
export default {
  data() {
    return {

      list_data: [],
      list_bidang: [],
      form: {
        id: null,
        nama: '',
        bidang_usaha_id: '',
        email: '',
        hp: '',
        alamat: '',
        status: ''
      },
      tipe: null, // simpan tipe user
      page_first: 1,
      page_last: 0,
      page_limit: 10,
      cari_value: '',
      mdl_add: false,
      mdl_edit: false,
      mdl_hapus: false,
      mdl_pic: false,
      mdl_catatan_admin: false,
      mdl_open: false,
      file_path: this.$store.state.url.URL_APP + "uploads/",
      selectedDocument: {
        file_name: ''
      },
      mdl_approve: false,
      approve_form: {
        username: '',
        password: ''
      },
      selectedItem: {},
      mdl_keterangan: false,
      pic_data: null,
      btn_add: false,
      btn_edit: false,
      btn_hapus: false,
      filterku: {
        master_bidang_usaha: ''  // filter pakai bidang
      },
      list_bidang: [],

      mdl_password: false,
      dataku: {
        users_id: '',
        password: '',
        confirmPassword: ''
      },
      errorMessage: '',
    }
  },
  methods: {
    getBidang() {
      fetch("/api/bidang_usaha")
        .then(res => res.json())
        .then(res_data => {
          this.list_bidang = res_data.data || [];
        });
    },
    // getView() {

    //   const body = {
    //     page_limit: this.page_limit,
    //     data_ke: (this.page_first - 1) * this.page_limit,
    //     cari_value: this.cari_value,
    //     master_bidang_usaha: this.filterku.master_bidang_usaha
    //   };

    //   if (this.tipe === 4) {
    //     // const userId = JSON.parse(localStorage.profile).profile.id;
    //     // body.users_id = userId;
    //     const profile = JSON.parse(localStorage.profile);
    //     console.log("User tipe 4, kirim users_id:", profile);
    //     body.users_id = profile._id; // pakai ini
    //   }

    //   fetch(this.$store.state.url.DATA_MITRA + "listRegis", {
    //     method: "POST",
    //     headers: {
    //       "content-type": "application/json",
    //       authorization: "kikensbatara " + localStorage.token
    //     },
    //     body: JSON.stringify(body)
    //   })
    //     .then(res => res.json())
    //     .then(res_data => {
    //       this.list_data = res_data.data;
    //       this.jml_data = res_data.jml_data;
    //       this.total_data = res_data.total_data;
    //       this.page_last = Math.ceil(this.total_data / this.page_limit);
    //     });
    // },

    // getView() {
    //   const body = {
    //     page_limit: this.page_limit,
    //     data_ke: (this.page_first - 1) * this.page_limit,
    //     cari_value: this.cari_value,
    //     master_bidang_usaha: this.filterku.master_bidang_usaha,
    //   };

    //   fetch(this.$store.state.url.DATA_MITRA + "listRegis", {
    //     method: "POST",
    //     headers: {
    //       "content-type": "application/json",
    //       authorization: "kikensbatara " + localStorage.token
    //     },
    //     body: JSON.stringify(body)
    //   })
    //     .then(res => res.json())
    //     .then(res_data => {
    //       // console.log("Respons API listRegis:", res_data); 
    //       if (res_data.data && res_data.data.length > 0) {
    //         res_data.data.forEach(item => {
    //           // console.log("Item data.status:", item.status);  
    //         });
    //       } else {
    //         // console.log("list_data kosong atau tidak ada data");
    //       }
    //       this.list_data = res_data.data;
    //       this.jml_data = res_data.jml_data;
    //       this.total_data = res_data.total_data;
    //       this.page_last = Math.ceil(this.total_data / this.page_limit);
    //     })
    //     .catch(error => {
    //       console.error("Error fetching data:", error);
    //     });
    // },
    getView() {
  const body = {
    page_limit: this.page_limit,
    data_ke: (this.page_first - 1) * this.page_limit,
    cari_value: this.cari_value,
    master_bidang_usaha: this.filterku.master_bidang_usaha,
    tipe: this.tipe  // Tambahkan tipe user
  };

  // Jika tipe 4 (mitra), ambil users_id dari localStorage dan kirim
  if (this.tipe === 4) {
    const profile = JSON.parse(localStorage.profile);
    console.log('Profile structure:', profile);  // Debug: Cek struktur localStorage
    body.users_id = profile._id;  // Ubah ke _id (atau profile.profile._id jika nested)
  }

  fetch(this.$store.state.url.DATA_MITRA + "listRegis", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify(body)
  })
    .then(res => res.json())
    .then(res_data => {
      // console.log("Respons API listRegis:", res_data); 
      if (res_data.data && res_data.data.length > 0) {
        res_data.data.forEach(item => {
          // console.log("Item data.status:", item.status);  
        });
      } else {
        // console.log("list_data kosong atau tidak ada data");
      }
      this.list_data = res_data.data;
      this.jml_data = res_data.jml_data;
      this.total_data = res_data.total_data;
      this.page_last = Math.ceil(this.total_data / this.page_limit);
    })
    .catch(error => {
      console.error("Error fetching data:", error);
    });
},
    addData() {
      this.btn_add = true;
      fetch("/api/perusahaan/add", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(this.form)
      })
        .then(() => {
          this.btn_add = false;
          this.mdl_add = false;
          this.getView();
        });
    },
    editData() {
      this.btn_edit = true;
      fetch("/api/perusahaan/edit", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(this.form)
      })
        .then(() => {
          this.btn_edit = false;
          this.mdl_edit = false;
          this.getView();
        });
    },
    lihatPIC(users_id) {
      fetch(this.$store.state.url.DATA_MITRA + "viewPIC", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({ users_id })
      })
        .then(res => res.json())
        .then(res_data => {
          if (res_data.success) {
            this.pic_data = res_data.data;
            this.mdl_pic = true;
          } else {
            this.$q.notify({ type: "negative", message: res_data.message });
          }
        })
        .catch(err => {
          console.error(err);
          this.$q.notify({ type: "negative", message: "Gagal ambil data PIC" });
        });
    },

    getBidang() {
      fetch(this.$store.state.url.DATA_MITRA + "viewBidang", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({})
      })
        .then(res => res.json())
        .then(res_data => {
          // console.log("📌 hasil bidang:", res_data); // debug
          this.list_bidang = res_data.data || [];
        });
    },

    selectData(data) {
      this.dataku = {
        users_id: data.users_id,
        password: '',
        confirmPassword: ''
      };
      this.errorMessage = '';

    },

    selectData(data) {
      this.dataku = {
        users_id: data.users_id,
        password: '',
        confirmPassword: ''
      };
      this.errorMessage = '';
      this.form = {
        ...data,
        users_id: data.users_id,
        id: data.id 
      };
    },

    async editDataPassword() {
      this.errorMessage = '';

      if (!this.dataku.password || !this.dataku.confirmPassword) {
        this.errorMessage = "Password dan Confirm Password wajib diisi!";
        return;
      }

      if (this.dataku.password !== this.dataku.confirmPassword) {
        this.errorMessage = "Password dan Confirm Password tidak sama!";
        return;
      }

      try {
        const res = await fetch(this.$store.state.url.DATA_MITRA + "editPassword", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            users_id: this.dataku.users_id,
            password: this.dataku.password
          })
        });

        const data = await res.json();

        if (data.success) {
          this.$q.notify({ type: "positive", message: "Password berhasil diubah!" });
          this.mdl_password = false;
        } else {
          this.errorMessage = data.message || "Gagal mengubah password!";
        }
      } catch (error) {
        console.error(error);
        this.errorMessage = "Terjadi kesalahan saat mengubah password.";
      }
    },

    editData() {
      this.btn_edit = true;
      fetch(this.$store.state.url.DATA_MITRA + "EditMitra", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          users_id: this.form.users_id,
          perusahaan_id: this.form.id,
          password: this.form.password || "", 
          nama: this.form.pic_nama,
          jabatan: this.form.pic_jabatan,
          pic_email: this.form.pic_email,
          pic_hp: this.form.pic_hp,
          perusahaan_nama: this.form.nama,
          bidang_usaha_id: this.form.bidang_usaha_id,
          perusahaan_email: this.form.email,
          perusahaan_hp: this.form.hp,
          alamat: this.form.alamat
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.btn_edit = false;
          if (res_data.success) {
            this.mdl_edit = false;
            this.getView();
            this.$q.notify({ type: 'positive', message: res_data.message });
          } else {
            this.$q.notify({ type: 'negative', message: res_data.error || 'Gagal update' });
          }
        })
        .catch(err => {
          this.btn_edit = false;
          this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan' });
        });
    },
    indexing(idx) {
      return ((this.page_first - 1) * this.page_limit) + idx;
    },
    editModal(data) {
      this.form = {
        ...data,
        pic_nama: data.nama_pic || '',
        pic_jabatan: data.jabatan || '',
        pic_email: data.email_pic || '',
        pic_hp: data.hp_pic || ''
      };
      this.mdl_edit = true;
    },

    hapusData() {
      this.btn_hapus = true;
      fetch(this.$store.state.url.DATA_MITRA + "hapusmitra", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        },
        body: JSON.stringify({
          users_id: this.form.users_id, 
          perusahaan_id: this.form.id
        })
      })
        .then(res => res.json())
        .then(res_data => {
          this.btn_hapus = false;
          if (res_data.success) {
            this.mdl_hapus = false;
            this.getView(); 
            this.$q.notify({ type: 'positive', message: res_data.message });
          } else {
            this.$q.notify({ type: 'negative', message: res_data.error || 'Gagal hapus' });
          }
        })
        .catch(err => {
          this.btn_hapus = false;
          this.$q.notify({ type: 'negative', message: 'Terjadi kesalahan' });
        });
    },
    lihatModal(data) {
      this.lihatPIC(data.users_id);
    },
    cari_data() { this.page_first = 1; this.getView(); },

    lihatKeterangan: function (item) {
      this.selectedItem = { ...item };
      this.mdl_keterangan = true;
    },

    approveRegistrasi(id) {
      const item = this.list_data.find(d => d.id === id);
      if (!item) {
        this.Notify('Data tidak ditemukan', 'negative', 'warning');
        return;
      }
      this.selectedItem = { ...item };
      this.approve_form = { username: '', password: '' }; 
      this.mdl_approve = true;
    },

    async submitApprove() {
      if (!this.approve_form.username.trim() || !this.approve_form.password.trim()) {
        this.Notify('Username dan Password harus diisi', 'negative', 'warning');
        return;
      }

      try {
        const res = await fetch(this.$store.state.url.DATA_MITRA + "approveRegistrasi", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            id: this.selectedItem.id,
            username: this.approve_form.username,
            password: this.approve_form.password
          })
        });
        const data = await res.json();
        if (data.success) {
          this.Notify('Registrasi disetujui dan akun dibuat', 'positive', 'check_circle_outline');
          this.mdl_approve = false;
          this.getView();  
        } else {
          this.Notify(data.message || 'Gagal menyetujui registrasi', 'negative', 'error_outline');
        }
      } catch (err) {
        console.error(err);
        this.Notify('Terjadi kesalahan server', 'negative', 'error_outline');
      }
    },

    tolakRegistrasi(id) {
      const item = this.list_data.find(d => d.id === id);
      if (!item) {
        this.Notify('Data tidak ditemukan', 'negative', 'warning');
        return;
      }
      this.selectedItem = { ...item, catatan_admin: '' }; 
      this.mdl_catatan_admin = true;
    },

    async submitTolak() {
      if (!this.selectedItem.catatan_admin.trim()) {
        this.Notify('Catatan admin harus diisi', 'negative', 'warning');
        return;
      }

      const confirm = window.confirm('Apakah Anda yakin ingin menolak registrasi ini? Status akan berubah ke "ditolak".');
      if (!confirm) return;

      try {
        const res = await fetch(this.$store.state.url.DATA_MITRA + "tolakRegistrasi", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            authorization: "kikensbatara " + localStorage.token 
          },
          body: JSON.stringify({
            id: this.selectedItem.id,
            catatan_admin: this.selectedItem.catatan_admin
          })
        });
        const data = await res.json();
        if (data.success) {
          this.Notify('Registrasi ditolak dan catatan disimpan', 'negative', 'cancel');
          this.getView(); 
          this.mdl_catatan_admin = false;
        } else {
          this.Notify(data.message, 'negative', 'error_outline');
        }
      } catch (err) {
        console.error(err);
        this.Notify('Terjadi kesalahan server', 'negative', 'error_outline');
      }
    },

    Notify: function (message, positive, icon) {
      this.$q.notify({
        message: message,
        color: positive,
        icon: icon,
        position: 'top',
        timeout: 500,
      })
    },

    openDocumentModal(data) {
      console.log("Data yang diklik:", data);
      const fileName = data.file_name || ''; 
      this.selectedDocument = { file_name: fileName };
      this.mdl_open = true;  
    },


    handleFileError() {
      this.$q.notify({
        type: 'negative',
        message: 'Gagal memuat dokumen.',
        icon: 'error'
      });
    },

    // downloadFile() {
    //   if (this.selectedDocument.file_name) {
    //     const link = document.createElement('a');
    //     link.href = this.file_path + this.selectedDocument.file_name;
    //     link.download = this.selectedDocument.file_name;  
    //     link.click();
    //   } else {
    //     this.$q.notify({
    //       type: 'negative',
    //       message: 'File tidak tersedia.',
    //       icon: 'warning'
    //     });
    //   }
    // },

  },
  mounted() {
    const get_profile = JSON.parse(localStorage.profile);
    this.tipe = Number(get_profile.profile.db_csrkonsel); // ambil db_csrkonsel
    this.getView();
    this.getBidang();
  }
}
